import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center mt-8 rounded-t" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg-monteria-banner" }, null, -1)
const _hoisted_3 = { class: "font-bold text-4xl pt-4 text-white decoration-curaduria" }
const _hoisted_4 = { class: "flex flex-row place-content-center items-center w-full p-2 mapsLocation" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://www.google.com/maps/embed?pb=!4v1651202068299!6m8!1m7!1saFcQE01gOa6DR0Mfno3FFw!2m2!1d8.754232107618828!2d-75.88833816308244!3f37.62594127705934!4f2.186774495683707!5f0.7820865974627469",
  style: {"border":"0","height":"500px"},
  loading: "lazy",
  scrolling: "no",
  frameborder: "0",
  class: "w-2/5 mt-4 iframeLocation",
  referrerpolicy: "no-referrer-when-downgrade"
}, null, -1)
const _hoisted_6 = {
  class: "w-2/5 mt-4 p-2 iframeLocation",
  style: {"pointer-events":"none"}
}

export function render(_ctx, _cache) {
  const _component_ol_view = _resolveComponent("ol-view")
  const _component_ol_fullscreen_control = _resolveComponent("ol-fullscreen-control")
  const _component_ol_attribution_control = _resolveComponent("ol-attribution-control")
  const _component_ol_source_osm = _resolveComponent("ol-source-osm")
  const _component_ol_tile_layer = _resolveComponent("ol-tile-layer")
  const _component_ol_overviewmap_control = _resolveComponent("ol-overviewmap-control")
  const _component_ol_scaleline_control = _resolveComponent("ol-scaleline-control")
  const _component_ol_rotate_control = _resolveComponent("ol-rotate-control")
  const _component_ol_zoom_control = _resolveComponent("ol-zoom-control")
  const _component_ol_zoomslider_control = _resolveComponent("ol-zoomslider-control")
  const _component_ol_geom_point = _resolveComponent("ol-geom-point")
  const _component_ol_style_icon = _resolveComponent("ol-style-icon")
  const _component_ol_style = _resolveComponent("ol-style")
  const _component_ol_feature = _resolveComponent("ol-feature")
  const _component_ol_source_vector = _resolveComponent("ol-source-vector")
  const _component_ol_vector_layer = _resolveComponent("ol-vector-layer")
  const _component_ol_map = _resolveComponent("ol-map")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("location.title")), 1),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ol_map, {
          loadTilesWhileAnimating: true,
          loadTilesWhileInteracting: true,
          style: {"height":"500px","border":"0"},
          class: "olmapLocation"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ol_view, {
              ref: "view",
              center: _ctx.center,
              rotation: _ctx.rotation,
              zoom: _ctx.zoom,
              projection: _ctx.projection
            }, null, 8, ["center", "rotation", "zoom", "projection"]),
            (_ctx.fullscreencontrol)
              ? (_openBlock(), _createBlock(_component_ol_fullscreen_control, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.attributioncontrol)
              ? (_openBlock(), _createBlock(_component_ol_attribution_control, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.overviewmapcontrol)
              ? (_openBlock(), _createBlock(_component_ol_overviewmap_control, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ol_tile_layer, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ol_source_osm)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.scalelinecontrol)
              ? (_openBlock(), _createBlock(_component_ol_scaleline_control, { key: 3 }))
              : _createCommentVNode("", true),
            (_ctx.rotatecontrol)
              ? (_openBlock(), _createBlock(_component_ol_rotate_control, { key: 4 }))
              : _createCommentVNode("", true),
            (_ctx.zoomcontrol)
              ? (_openBlock(), _createBlock(_component_ol_zoom_control, { key: 5 }))
              : _createCommentVNode("", true),
            (_ctx.zoomslidercontrol)
              ? (_openBlock(), _createBlock(_component_ol_zoomslider_control, { key: 6 }))
              : _createCommentVNode("", true),
            _createVNode(_component_ol_tile_layer, null, {
              default: _withCtx(() => [
                _createVNode(_component_ol_source_osm)
              ]),
              _: 1
            }),
            _createVNode(_component_ol_vector_layer, null, {
              default: _withCtx(() => [
                _createVNode(_component_ol_source_vector, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ol_feature, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ol_geom_point, { coordinates: _ctx.coordinate }, null, 8, ["coordinates"]),
                        _createVNode(_component_ol_style, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ol_style_icon, {
                              src: "../../../pointer.png",
                              scale: 1.2
                            }, null, 8, ["scale"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}